import {AdvancedTable, useAdvancedTable, useFilterContext} from '@eitje/web_components'
import {columns} from './columns'
import {TABLE_INFO} from './constants'

export const EnvironmentsAdvancedTable = () => {
	'use no memo' // @tanstack/react-table is not compatible with the react compiler
	const {items} = useFilterContext()

	const rowModalLink = row => `${row.original.id}/edit`

	const tableData = useAdvancedTable({data: items, columns, TABLE_INFO})

	return <AdvancedTable data={tableData} rowModalLink={rowModalLink} />
}
